
export const QUERIES = {
  STUDY_QUERY: `
    SELECT 
      main.StudyInstanceUID,
      COUNT(*) AS InstanceCount,
      ANY_VALUE(StudyDate) AS StudyDate,
      ANY_VALUE(StudyDescription) AS StudyDescription,
      ANY_VALUE(PatientID) AS PatientID,
      ANY_VALUE(Modality) AS Modality,
      ANY_VALUE(DeviceSerialNumber) AS DeviceSerialID,
      ANY_VALUE(InstitutionName) AS Institution,
      ANY_VALUE(private_data.studyCondition) AS StudyCondition,
      ANY_VALUE(private_data.HumanSubjectId) AS HumanSubjectId,
      ROW_NUMBER() OVER (ORDER BY main.StudyInstanceUID) AS id
    FROM 
      upload-portal-443516.dicomUpload.studyData AS main
    LEFT JOIN (
      SELECT 
        StudyInstanceUID,
        JSON_EXTRACT_SCALAR(ARRAY_TO_STRING(OtherElements.Data, ''), '$.studyCondition') AS StudyCondition,
        JSON_EXTRACT_SCALAR(ARRAY_TO_STRING(OtherElements.Data, ''), '$.HumanSubjectId') AS HumanSubjectId
      FROM 
        upload-portal-443516.dicomUpload.studyData,
        UNNEST(OtherElements) AS OtherElements
      WHERE 
        OtherElements.Tag = "Tag_2F470010"
    ) AS private_data
    ON main.StudyInstanceUID = private_data.StudyInstanceUID
GROUP BY 
    main.StudyInstanceUID`,

  STUDY_QUERY_WITH_FILTERS: (institution?: string, studyCondition?: string, humanSubjectId?: string) => {
    let whereClause = '';
    const conditions = [];
    
    if (institution) {
      conditions.push(`UPPER(InstitutionName) LIKE UPPER('%${institution}%')`);
    }
    
    if (studyCondition) {
      conditions.push(`UPPER(private_data.studyCondition) LIKE UPPER('%${studyCondition}%')`);
    }
    
    if (humanSubjectId) {
      conditions.push(`UPPER(private_data.HumanSubjectId) LIKE UPPER('%${humanSubjectId}%')`);
    }
    
    if (conditions.length > 0) {
      whereClause = `WHERE ${conditions.join(' AND ')}`;
    }
    
    return `
      SELECT 
        StudyInstanceUID,
        COUNT(*) AS InstanceCount,
        ANY_VALUE(StudyDate) AS StudyDate,
        ANY_VALUE(StudyDescription) AS StudyDescription,
        ANY_VALUE(PatientID) AS PatientID,
        ANY_VALUE(Modality) AS Modality,
        ANY_VALUE(DeviceSerialNumber) AS DeviceSerialID,
        ANY_VALUE(InstitutionName) AS Institution,
        ANY_VALUE(private_data.studyCondition) AS StudyCondition,
        ANY_VALUE(private_data.HumanSubjectId) AS HumanSubjectId,
        ROW_NUMBER() OVER (ORDER BY main.StudyInstanceUID) AS id
      FROM 
        upload-portal-443516.dicomUpload.studyData
      LEFT JOIN (
        SELECT 
          StudyInstanceUID,
          JSON_EXTRACT_SCALAR(ARRAY_TO_STRING(OtherElements.Data, ''), '$.studyCondition') AS StudyCondition,
          JSON_EXTRACT_SCALAR(ARRAY_TO_STRING(OtherElements.Data, ''), '$.HumanSubjectId') AS HumanSubjectId
        FROM 
          upload-portal-443516.dicomUpload.studyData,
          UNNEST(OtherElements) AS OtherElements
        WHERE 
          OtherElements.Tag = "Tag_2F470010"
      ) AS private_data
      ON main.StudyInstanceUID = private_data.StudyInstanceUID
      ${whereClause}
      GROUP BY 
      main.StudyInstanceUID`;
  },

  SERIES_QUERY: (studyInstanceUID: string) => `
    SELECT
      COUNT(*) AS InstanceCount,
      SeriesNumber,
      SeriesInstanceUID,
      SeriesDescription,
      ANY_VALUE(Modality) AS Modality,
      ANY_VALUE(DeviceSerialNumber) AS DeviceSerialID,
      ANY_VALUE(InstitutionName) AS Institution
    FROM
      upload-portal-443516.dicomUpload.studyData
    WHERE
      StudyInstanceUID = '${studyInstanceUID}'
    GROUP BY
      SeriesInstanceUID, SeriesDescription, SeriesNumber`,
};
